import type { ApiSearchQuery } from "@/lib/api/api-type-helper";
import { apiClient } from "@/lib/api/client";
import { getPath } from "@/lib/api/path";
import { remainingTimeToday } from "@/lib/query";
import { useQuery } from "@tanstack/react-query";

interface StateProvince {
  id: string;
  value: string;
  label: string;
  keywords?: string[];
}

export const useStateProvinces = (
  country?: ApiSearchQuery<"/v2/division/state-provinces", "get">["country"],
) => {
  const { isLoading, error, data } = useQuery({
    queryKey: [getPath("/v2/division/state-provinces"), { country }] as const,
    queryFn: async ({ queryKey: [path, { country }] }) =>
      country
        ? (
            await apiClient.GET(path, {
              params: {
                query: { country },
              },
            })
          ).data
        : null,
    staleTime: remainingTimeToday(),
    enabled: !!country, // countryが有効な場合のみクエリを実行
  });

  const formattedStateProvinces: StateProvince[] =
    data?.items?.map((i) => ({
      id: i.id,
      value: i.id,
      label: i.label,
      keywords: i.keywords,
    })) || [];

  return { stateProvinces: formattedStateProvinces, error, isLoading };
};
